import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f7a61838&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=f7a61838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a61838",
  null
  
)

export default component.exports